"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var slide_1 = __importDefault(require("./slide"));
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var slots_slider_1 = __importDefault(require("@l2p/slots-slider"));
var gamesInOneSlide = 6;
var BlockWithGames = function (_a) {
    var gameCardPlaceholder = _a.gameCardPlaceholder, correctionCoefficient = _a.correctionCoefficient;
    var _b = (0, react_1.useState)(), slider = _b[0], setSlider = _b[1];
    var t = (0, next_intl_1.useTranslations)();
    var providerId = '';
    var games = [];
    var defaultGames = games;
    var providerInfo = {};
    var gamesBlocks = (0, apps_shared_1.useGenerateSlideBlocks)({
        cards: games.length > 0 ? games : defaultGames,
        cardsInSlide: 5,
        countSlides: 5,
    });
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.blockWrapper },
        react_1.default.createElement(ui_components_1.TopBar, { setPrevSlide: slider === null || slider === void 0 ? void 0 : slider.setPrevSlide, setNextSlide: slider === null || slider === void 0 ? void 0 : slider.setNextSlide, title: providerInfo ? (providerInfo === null || providerInfo === void 0 ? void 0 : providerInfo.name) || '' : t('common.allGames'), showNavigationButtons: !!gamesBlocks && gamesBlocks.length > 1, linkAddress: "/providers/".concat(providerId.toLowerCase()) }),
        gamesBlocks && gamesBlocks.length ? (react_1.default.createElement(slots_slider_1.default, { duration: 1, getSliderMethods: function (slider) { return setSlider(slider); }, columnsCount: 5, gapBetweenCards: 15, rowsCount: 1, correctionCoefficient: correctionCoefficient }, gamesBlocks.map(function (gamesPerSlide, idx) { return (react_1.default.createElement(slide_1.default, { gameCardPlaceholder: gameCardPlaceholder, games: gamesPerSlide, key: "providerGamesSlide_".concat(gamesPerSlide[0].id).concat(idx) })); }))) : (react_1.default.createElement(ui_components_1.EmptyGamesSliderPlaceholder, { gamesInSlide: gamesInOneSlide, rowCount: 1 }))));
};
exports.default = BlockWithGames;
